import moment from 'moment'
import { columnHelper } from '../../../iba-components/Table'

export const getColumnList = (t) => [
    columnHelper.accessor('id', {
        header: t('clientManagement.clientId'),
        cell: (props) => `0000000000${props.getValue()}`.slice(-10)
    }),
    columnHelper.accessor('companyname', {
        header: t('clientManagement.companyName'),
        size: 250
    }),
    columnHelper.accessor('industries', {
        header: t('clientManagement.industries')
    }),
    columnHelper.accessor('contractdate', {
        header: t('clientManagement.contractDate'),
        cell: (props) => (props.getValue() ? moment(props.getValue()).format('YYYY-MM-DD') : '')
    }),
    columnHelper.accessor('status', {
        header: t('clientManagement.terminated'),
        size: 80,
        cell: (props) => {
            const status = props.getValue()
            return status === 0
                ? t('clientManagement.isActive')
                : status === 1
                ? t('clientManagement.isStop')
                : status === 2
                ? t('clientManagement.isTerminated')
                : t('clientManagement.isErrored')
        }
    }),
    columnHelper.accessor('is_trial', {
        header: t('clientManagement.trial'),
        size: 80,
        cell: (props) => (props.getValue() ? '○' : '')
    })
]
